import React, { Dispatch, SetStateAction } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
// import {BasicButton} from './UI/BasicButton'
import { BasicButton } from '../../../widgets/components/UI/BasicButton'

export const DeleteClassificationModal = ({
  showDeleteModal,
  setDeleteShowModal,
  headingMessage,
  description,
  handleDelete,
  deleteLoading,
  warningText,
  action,
}: {
  showDeleteModal: boolean
  setDeleteShowModal: Dispatch<SetStateAction<boolean>>
  headingMessage: string
  description: string
  handleDelete?: any
  deleteLoading?: boolean
  id?: any
  warningText?: string
  action?: string
}) => {
  const { formatMessage } = useIntl()

  return (
    <Modal
      show={showDeleteModal}
      onHide={() => setDeleteShowModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <h2>{formatMessage({ id: headingMessage })}</h2>
      </Modal.Header>
      <Modal.Body>
        <p>
          {formatMessage({
            id: description,
          })}
        </p>
        {warningText && <p className='text-danger font-size'>Warning: {warningText}</p>}
      </Modal.Body>

      <Modal.Footer>
        <BasicButton
          height='44px'
          border='none'
          color='#F5F8FA'
          textColor='#7E8299'
          padding='12px 16px'
          onClick={() => {
            setDeleteShowModal(false)
          }}
          buttonText='Cancel'
          // minWidth={56}
          customClass='w-100 w-md-auto order-2 order-md-1'
        />

        <BasicButton
          height='44px'
          border='none'
          color={action === 'Accept' ? '#4776E6' : 'red'}
          textColor='white'
          padding='12px 24px'
          onClick={() => {
            handleDelete()
          }}
          buttonText={
            action === 'Reject' ? 'Deny Request' : action === "Accept" ? 'Approve Request' : 'Confirm Delete'
          }
          minWidth={56}
          loading={deleteLoading}
          disabled={deleteLoading}
          customClass='w-100 w-md-auto order-1 order-md-2'
        />
      </Modal.Footer>
    </Modal>
  )
}
